// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"cb19f4c0eda505fccfab","655":"ca890694bd8b2c2b47f7"}[chunkId] + ".js";
};